
import { PostgrestError } from '@supabase/supabase-js';
import { SaveStateParams } from '../useSaveStateMutations';
import { supabase } from '@/integrations/supabase/client';

/**
 * Checks if a state with the given name already exists
 */
export const checkNameUniqueness = async (name: string): Promise<{ exists: boolean, error?: PostgrestError }> => {
  const { data, error } = await supabase
    .from('saved_states')
    .select('id')
    .eq('name', name)
    .maybeSingle();
    
  return { 
    exists: !!data,
    error: error || undefined
  };
};

/**
 * Checks if a state with the given country/league/year combination exists
 */
export const checkCombinationExists = async (
  country: string, 
  league: string, 
  year: string
): Promise<{ data: { id: number } | null, error?: PostgrestError }> => {
  const { data, error } = await supabase
    .from('saved_states')
    .select('id')
    .eq('country', country)
    .eq('league', league)
    .eq('year', year)
    .maybeSingle();
    
  return { 
    data,
    error: error || undefined
  };
};

/**
 * Updates an existing state record
 */
export const updateExistingState = async (
  id: number,
  { name, country, league, year, data }: SaveStateParams
) => {
  return await supabase
    .from('saved_states')
    .update({ name, country, league, year, data })
    .eq('id', id)
    .select()
    .single();
};

/**
 * Inserts a new state record
 */
export const insertNewState = async ({ name, country, league, year, data }: SaveStateParams) => {
  return await supabase
    .from('saved_states')
    .insert([{ name, country, league, year, data }])
    .select()
    .single();
};

